export const ERequestStatus = {
  CANCELED: 'canceled',
  FAILED: 'failed',
  PENDING: 'pending',
  REJECTED: 'rejected',
  PROCESSED: 'processed',
  QUEUED: 'queued'
} as const;

export type ERequestStatus =
  (typeof ERequestStatus)[keyof typeof ERequestStatus];
